module.exports = __webpack_public_path__ + "img/robopat.d1b427de.png";